import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { alterarTipoItem, type AlterarTipoItemPayload } from '../api/ProdutoApi';

export function useAlterarTipoItem() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (payload: AlterarTipoItemPayload) => alterarTipoItem(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['segregacao-calcular'] });
      toast({ title: 'Tipo item alterado com sucesso.' });
    },
    onError: () => {
      toast({
        variant: 'destructive',
        title: 'Erro ao alterar tipo item',
        description: 'Não foi possível completar a operação. Tente novamente.',
      });
    },
  });
}
